const VARIANTS = {
  verified:    'bg-green-100 text-green-800',
  unverified:  'bg-gray-100 text-gray-600',
  pending:     'bg-yellow-100 text-yellow-800',
  rejected:    'bg-red-100 text-red-800',
  available:   'bg-emerald-100 text-emerald-800',
  unavailable: 'bg-gray-100 text-gray-500',
  on_job:      'bg-blue-100 text-blue-800',
  active:      'bg-green-100 text-green-800',
  closed:      'bg-gray-100 text-gray-600',
  critical:    'bg-red-100 text-red-800',
  high:        'bg-orange-100 text-orange-800',
  medium:      'bg-yellow-100 text-yellow-800',
  low:         'bg-gray-100 text-gray-600',
};

export default function Badge({ label, variant, className = '' }) {
  const cls = VARIANTS[variant] || 'bg-gray-100 text-gray-600';
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${cls} ${className}`}>
      {label}
    </span>
  );
}
